import React, { useEffect } from 'react';
import Description from '../common/Description';
import { fetchFigure } from '../../store/actions/figure';
import { connect } from 'react-redux';
import Chart from './charts/Chart';
import Spinner from '../common/Spinner';
import { Link } from 'react-router-dom';
import OpenFile from '../../components/common/OpenFile';
import Relations from '../common/Relations';
import ReactGA from 'react-ga';
import { language } from '../../common/language';
import { removeTrailingForwardSlashes } from '../../common/utils';

/* eslint-disable react/prop-types */
export const Figure = props => {
  const { fetchFigure } = props;

  useEffect(() => {
    fetchFigure(props.selectedFigure);
  }, [props.selectedFigure, fetchFigure]);

  let link = `${removeTrailingForwardSlashes(window.location.pathname)}/figur/${
    props.selectedFigure.label
  }`;

  return (
    <React.Fragment>
      {props.figure && props.figure.figures ? (
        <React.Fragment>
          <div className="mt-2 pr-2 open-table-new-tab">
            <Link
              to={link}
              onClick={ev => {
                ReactGA.event({
                  category:
                    props.selectedFigure.shortName +
                    ' ' +
                    props.selectedFigure.year,
                  action: 'Open details view',
                  label: 'Figure ' + props.selectedFigure.label
                });
                ev.preventDefault();
                window.open(link);
              }}
            >
              <OpenFile /> Åpne figur i ny fane
            </Link>
          </div>
          {props.figure.figures &&
            props.figure.figures.map((figure, index) => {
              return (
                <div className="mt-3" key={index}>
                  <Chart figure={figure} />
                </div>
              );
            })}
          <Description description={props.figure.description} />
          <Relations relations={props.figure.relationships} />
          <span>
            {language(props.figure.language, 'source')}: {props.figure.source}
          </span>
        </React.Fragment>
      ) : (
        <Spinner />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    figure: state.figure.figure
  };
};

export default connect(mapStateToProps, { fetchFigure })(Figure);
